// import React from "react";
import React, { useEffect, useState } from 'react';
import { getAllDesignation } from '../../api/designationApi';
import { getAllDepartment } from '../../api/departmentApi';
import { getAllSection } from '../../api/sectionApi';
import { getAllGrade } from '../../api/gradeApi';
import { getAllEducation } from '../../api/educationApi';


const Step2EmploymentDetails = ({ formData, handleChange, nextStep, prevStep }) => {

  // department, section, Grade, Education
  const [designationList, setDesignationList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [educationList, setEducationList] = useState([]);

  useEffect(() => {
      const fetchData = async () => {
        try {
          // const data = await getAllDesignation();
          // setDesignationList(data); 

          const departments = await getAllDepartment();
          setDepartmentList(departments);

          const designations = await getAllDesignation();
          setDesignationList(designations);

          // const departments = await getAllDepartment();
          // setDepartmentList(departments);

          const sections = await getAllSection();
          setSectionList(sections);

          const grades = await getAllGrade();
          setGradeList(grades);

          const educations = await getAllEducation();
          setEducationList(educations);

        } catch (error) {
          console.error('Error fetching designations:', error);
        }
      };

      fetchData();
    }, []);

    const isNextEnabled =
      formData.designationID !== "" &&
      formData.departmentID !== "" &&
      formData.sectionID !== "" &&
      formData.gradeId !== "" &&
      formData.educationID !== "" &&
      formData.joiningDate !=="";


  return (
    
    <div className="container mt-4" style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
      {/* <div className="card mb-4">
        <div className="card-header bg-secondary text-white">Job Information</div> */}
      <div className="card mb-4">
        <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
          <span>Job Information</span>
          <span>{formData.fName} {formData.lName}</span>
        </div>
        <div className="card-body row g-3">
          <div className="col-md-4">
            <label>Designation <span className="text-danger">*</span></label>
            <select className="form-select" value={formData.designationID} onChange={handleChange("designationID")}>
              <option value="">Select</option>
                {designationList.map((designation) => (
                  <option key={designation.designationID} value={designation.designationID}>
                  {designation.name}
              </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>Department <span className="text-danger">*</span></label>
            <select className="form-select" value={formData.departmentID} onChange={handleChange("departmentID")}>
              <option value="">Select</option>
                {departmentList.map((department) => (
                  <option key={department.departmentID} value={department.departmentID}>
                  {department.departmentName}
              </option>
              ))}
            </select>
          </div>


          <div className="col-md-4">
            <label>Section <span className="text-danger">*</span></label>
            <select className="form-select" value={formData.sectionID} onChange={handleChange("sectionID")} >
              <option value="">Select</option>
              {sectionList
                .filter((s) => s.departmentID === parseInt(formData.departmentID)) // ✅ filter here
                .map((section) => (
                  <option key={section.sectionID} value={section.sectionID}>
                    {section.sectionName}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>Grade <span className="text-danger">*</span></label>
            <select className="form-select" value={formData.gradeId} onChange={handleChange("gradeId")}>
              <option value="">Select</option>
                {gradeList.map((grade) => (
                  <option key={grade.gradeID} value={grade.gradeID}>
                  {grade.gradeName}
              </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>
              Education <span className="text-danger">*</span>
            </label>
            <select className="form-select" value={formData.educationID} onChange={handleChange("educationID")}>
              <option value="">Select</option>
                {educationList.map((education) => (
                  <option key={education.educationID} value={education.educationID}>
                  {education.degreeLevel}
              </option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>Joining Date <span className="text-danger">*</span> </label>
            <input type="date" className="form-control" value={formData.joiningDate} onChange={handleChange("joiningDate")} />
          </div>

          <div className="col-md-4">
            <label>Employee Type</label>
            <select className="form-select" value={formData.employeeType} onChange={handleChange("employeeType")}>
              <option value="">Select</option>
              <option value="Full-Time">Full-Time</option>
              <option value="Part-Time">Part-Time</option>
            </select>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <button className="btn btn-secondary" onClick={prevStep}>Back</button>
        <button className="btn btn-primary" onClick={nextStep} disabled={!isNextEnabled}>Next</button>
      </div>
    </div>
  );
};

export default Step2EmploymentDetails;
